// Copyright 2024, Imprivata, Inc.  All rights reserved.

export const Endpoints = {
  AAD_CONSENT_URL: '/am-portal-setup-svc/tenant-setup/v1/aad-consent-url/get',
  BUSINESS_EMAIL_VERIFICATION_REQUEST:
    '/am-portal-setup-svc/business-email-verification/v1/request',
  BUSINESS_EMAIL_VERIFICATION_CONFIRM:
    '/am-portal-setup-svc/business-email-verification/v1/confirm',
  COMPLETE_SETUP: '/am-portal-setup-svc/tenant-setup/v1/complete',
  CONSENT_CHECK: '/am-portal-svc/user-consent/v1/consent/check',
  CONSENT_SUBMIT: '/am-portal-svc/user-consent/v1/consent/submit',
  CONSENT_REVOKE: '/am-portal-svc/user-consent/v1/consent/revoke',
  DIR_FAILED_SYNC_FIND: '/am-portal-svc/directory/v1/directories/failed-sync/find',
  DIR_FIND: '/am-portal-svc/directory/v1/directories/find',
  DIR_SYNC_PROGRESS: '/am-portal-svc/directory/v1/directories/sync-progress/get',
  DOMAINS_VALIDATE: '/am-portal-setup-svc/tenant-service/v1/domains/validate',
  DOMAINS_VERIFY: '/am-portal-setup-svc/tenant-service/v2/domains/verify',
  DOMAINS_REGISTER: '/am-portal-setup-svc/tenant-service/v2/domains/register',
  DPA_CHECK: '/am-portal-setup-svc/user-consent/v2/consent/dpa-check',
  ENTRA_ID_AUTHN_TEST: '/am-portal-svc/entra-id/v1/entra-id/authentication/test',
  ENTRA_ID_CONSENT: '/am-portal-svc/entra-id/v1/entra-id-consent-url/get',
  ENTRA_ID_SETUP_COMPLETE: '/am-portal-svc/entra-id/v1/entra-id/setup',
  FIND_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/find/by-user-ids',
  GET_CLIENT_USER_SESSION: '/am-portal-svc/session/v1/client-user-session/get',
  GET_GROUPS: '/am-portal-svc/identity-group/v1/groups/find',
  GET_LANDING_PAGE: '/am-portal-svc/v2/landing-page/get',
  GET_LANDING_PAGE_V3: '/am-portal-svc/v3/landing-page/get',
  GET_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/get',
  IDP_CONFIG_SAML_FIND: '/am-portal-setup-svc/icp-config-admin/v1/idp-config-saml/find',
  IP_RANGES: '/am-portal-svc/entra-id/v1/entra-id-config/get',
  GROUPS_FIND: '/am-portal-svc/identity-group/v1/groups/find',
  LOGOUT: '/idp-web/idp/logout',
  ORG_INFO_GET: '/am-portal-setup-svc/organization-info/v1/get',
  ORG_INFO_SAVE: '/am-portal-setup-svc/organization-info/v1/save',
  PORTAL_CONFIG_SETTINGS_GET: '/am-portal-svc/config/v1/settings/get',
  PORTAL_CONFIG_SETTINGS_UPDATE: '/am-portal-svc/config/v1/settings/update',
  PORTAL_TEMP_CODE_ASSIGN: '/am-portal-svc/temp-code/v1/temp-code/assign',
  PORTAL_TEMP_CODE_METADATA_GET: '/am-portal-svc/temp-code/v1/temp-code-metadata/get',
  PORTAL_CREATE_CLIENT_CREDENTIAL:
    '/am-portal-svc/connect-administration/v1/client-credential/create',
  PORTAL_CREDENTIALS_FIND: '/am-portal-svc/credentials/v1/credentials/find',
  PORTAL_CREDENTIALS_DELETE: '/am-portal-svc/credentials/v1/credential/delete',
  PORTAL_IMPR_IDP_DIR_SAVE: '/am-portal-svc/impr-idp-directories/v1/save',
  PORTAL_IMPR_IDP_USER_DETAILS_GET: '/am-portal-svc/impr-idp-users/v1/user/get',
  PORTAL_IMPR_IDP_USERS_FIND: '/am-portal-svc/impr-idp-users/v1/find',
  PORTAL_IMPR_IDP_USERS_SAVE: '/am-portal-svc/impr-idp-users/v1/save',
  PORTAL_IMPR_IDP_USERS_DELETE: '/am-portal-svc/impr-idp-users/v1/delete',
  PORTAL_ORG_PREFERENCES_GET: '/am-portal-svc/preferences/v1/org-preferences/get',
  PORTAL_ORG_PREFERENCES_UPDATE: '/am-portal-svc/preferences/v1/org-preferences/update',
  PORTAL_IMPR_IDP_USERS_INVITE: '/am-portal-svc/impr-idp-users/v1/users/invite',
  PORTAL_IMPR_IDP_USERS_UNLOCK: '/am-portal-svc/impr-idp-users/v1/user/unlock',
  PORTAL_IMPR_IDP_USERS_FACTOR_LOCKOUT_CLEAR:
    '/am-portal-svc/impr-idp-users/v1/user/factor-lockout/clear',
  PORTAL_USERS_FACTOR_LOCKOUT_CLEAR: '/am-portal-svc/user/v1/user/factor-lockout/clear',
  PORTAL_PASSWORD_EXPIRATION: '/am-portal-svc/password-info/v1/get',
  PORTAL_USERS_UPLOAD_SUBMIT: '/am-portal-svc/users/upload/v1/import-file/submit',
  PORTAL_USERS_UPLOAD_TEMPLATE_GET: '/am-portal-svc/users/upload/v1/import-file-template/get',
  PORTAL_REPORTS_EPCS_AUDIT_GET: '/am-portal-svc/reports/v1/epcs-audit/get',
  PORTAL_REPORTS_LOGIN_ACTIVITY_GET: '/am-portal-svc/reports/v1/login-activity/get',
  PORTAL_REPORTS_ENROLLMENT_ACTIVITY_GET: '/am-portal-svc/reports/v1/enrollment-activity/get',
  PORTAL_REPORTS_AGENT_VERSION_GET: '/am-portal-svc/reports/v1/agent-version/get',
  PORTAL_REPORTS_USER_ENROLLMENT_GET: '/am-portal-svc/reports/v1/user-enrollment/get',
  SETUP_IMPR_IDP_DIR_ADD: '/am-portal-setup-svc/impr-idp-directories/v1/save',
  SETUP_ADMIN_EMAIL_CONFIRM: '/am-portal-setup-svc/impr-idp-directories/v1/admin-email/confirm',
  SETUP_CREATE_CLIENT_CREDENTIAL:
    '/am-portal-setup-svc/connect-administration/v1/client-credential/create',
  SETUP_LINK_REGENERATE: '/am-portal-setup-svc/tenant-setup/v1/setup-link/regenerate',
  START_TENANT_SETUP: '/am-portal-setup-svc/tenant-setup/v1/start',
  TENANT_LOOKUP_BY_DOMAIN: '/am-portal-svc/tenant-lookup/v1/tenants-by-domain/get',
  TENANT_INFO: '/am-portal-svc/tenant-service/v2/tenant-info/get',
  TRIALS_START: '/am-portal-svc/trials/v1/trial/start',
  UNENROLL_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/unenroll',
  USERS_FIND: '/am-portal-svc/user/v1/users/find',
  // typescript:S2068 hard-coded passwords
  SELF_SERVICE_CHANGE_PASSWORD: '/am-portal-svc/impr-idp-users/v1/password/change', // NOSONAR
  SELF_SERVICE_V1_ENROLL: '/am-portal-svc/user-self-service/v1/authenticator/enroll',
  SELF_SERVICE_V2_LANDING_PAGE_GET: '/am-portal-svc/user-self-service/v2/landing-page/get',
  SELF_SERVICE_OTP_CONFIRM: '/am-portal-svc/user-self-service/v2/email-verification/confirm',
  SELF_SERVICE_OTP_REQUEST: '/am-portal-svc/user-self-service/v2/email-verification/request',

  USER_WEB_SUPERVISED_ASSURANCE_CANCEL: '/user-web/supervised-assurance/v1/assurance/cancel',
  USER_WEB_SUPERVISED_ASSURANCE_START: '/user-web/supervised-assurance/v1/assurance/start',
  USER_WEB_SUPERVISED_ASSURANCE_IDENTITY_VERIFICATION_RECORD:
    '/user-web/supervised-assurance/v1/identity-verification/record',
  USER_WEB_SUPERVISED_ASSURANCE_AUTHENTICATOR_VERIFY:
    '/user-web/supervised-assurance/v1/authenticator/verify',
  USER_WEB_SUPERVISED_ASSURANCE_COMPLETE: '/user-web/supervised-assurance/v1/assurance/complete',

  USER_WEB_INDIVIDUAL_ASSURANCE_START: '/user-web/individual-assurance/v1/assurance/start',
  USER_WEB_INDIVIDUAL_ASSURANCE_CANCEL: '/user-web/individual-assurance/v1/assurance/cancel',
  USER_WEB_INDIVIDUAL_ASSURANCE_COMPLETE: '/user-web/individual-assurance/v1/assurance/complete',
  USER_WEB_INDIVIDUAL_ASSURANCE_AUTHENTICATOR_VERIFY:
    '/user-web/individual-assurance/v1/authenticator/verify',
  USER_WEB_INDIVIDUAL_ASSURANCE_ID_PROOFING_SESSION_START:
    '/user-web/individual-assurance/v1/id-proofing-session/start',
  USER_WEB_INDIVIDUAL_ASSURANCE_ID_PROOFING_STATUS_GET:
    '/user-web/individual-assurance/v1/id-proofing-status/get',
  USER_WEB_INDIVIDUAL_ASSURANCE_OTP_SEND_BY_EMAIL:
    '/user-web/individual-assurance/v1/otp/send/by-email',
  USER_WEB_INDIVIDUAL_ASSURANCE_OTP_SEND_BY_SMS:
    '/user-web/individual-assurance/v1/otp/send/by-sms',
  USER_WEB_INDIVIDUAL_ASSURANCE_OTP_VERIFY: '/user-web/individual-assurance/v1/otp/verify',

  LEGAL_AGREEMENTS_PREPARE: '/am-portal-svc/legal-agreements/v1/file-upload/prepare',
  LEGAL_AGREEMENTS_COMPLETE: '/am-portal-svc/legal-agreements/v1/file-upload/html-to-json/complete',
  LEGAL_AGREEMENTS_INFO_GET: '/am-portal-svc/legal-agreements/v1/customer-agreement-info/get',
  // Setup and Portal
  PREPARE_FILE_UPLOAD: '/am-portal-svc/file-access/v1/prepare-file-upload',
  SAVE_AND_UPDATE_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/save',
  IMPR_IDP_DIR_FIND: '/am-portal-svc/impr-idp-directories/v1/find',
  CONNECT_CLIENT_CREATE: '/am-portal-svc/connect-eamc/v1/client/create',
  IDP_GET: '/am-portal-svc/icp-metadata-admin/v1/idp/get',
  IDP_SAVE: '/am-portal-svc/icp-metadata-admin/v1/idp/save',
  IDP_GET_DATA: '/am-portal-svc/impr-idp-directories/v1/impr-idp-data/get',
  PASSWORD_POLICY_GET: '/am-portal-svc/config/v1/password-policy/get',
  PASSWORD_POLICY_UPDATE: '/am-portal-svc/config/v1/password-policy/update',
  AUTHENTICATION_STRENGTH_GET: '/am-portal-svc/config/v1/authentication-strength/get',
  AUTHENTICATION_STRENGTH_RULES_FIND: '/am-portal-svc/config/v1/authentication-strength-rules/find',
  AUTHENTICATION_STRENGTH_RULES_UPDATE:
    '/am-portal-svc/config/v1/authentication-strength-rules/update',
  RULE_SETS_GET: '/am-portal-svc/rba-policy/v1/rulesets/get',
  RBA_POLICY_GET: '/am-portal-svc/rba-policy/v1/policy/get',
  RBA_POLICY_SET: '/am-portal-svc/rba-policy/v1/policy/set',
  APP_INTEGRATION_FIND_BY_NAME: '/admin-web/applications/v2/app-integration/find/by-name',
  APP_CONFIG_FIND: '/admin-web/application-config/v1/app-config/find',
  APP_CONFIG_UPDATE: '/admin-web/application-config/v1/app-config/update',
  PROX_CARD_MAX_NUMBER_GET: '/am-portal-svc/config/v1/prox-card-max-number/get',
  PROX_CARD_MAX_NUMBER_UPDATE: '/am-portal-svc/config/v1/prox-card-max-number/update',
  FACE_DUPLICATE_PREVENTION_GET: '/am-portal-svc/config/v1/face-duplicate-prevention/get',
  FACE_DUPLICATE_PREVENTION_UPDATE: '/am-portal-svc/config/v1/face-duplicate-prevention/update',
  IDV_CONNECTIONS_FIND: '/am-portal-svc/oidc-integrations-admin/v1/find',
  IDV_CONNECTION_GET: '/am-portal-svc/oidc-integrations-admin/v1/get',
  IDV_CONNECTIONS_CREATE: '/am-portal-svc/oidc-integrations-admin/v1/create',
  IDV_CONNECTIONS_UPDATE: '/am-portal-svc/oidc-integrations-admin/v1/update',
  IDV_CONNECTIONS_DELETE: '/am-portal-svc/oidc-integrations-admin/v1/delete',
  // Endpoints management (LYRA-1744)
  ENDPOINT_DEVICES_FIND: '/admin-web/endpoint-device/v2/endpoint-devices-with-agent-info/find',
  ENDPOINT_INSTALLER_DATA_GET: '/admin-web/endpoint/v3/endpoint-installer-data/get',
  ENDPOINT_INSTALLATION_KEY_GENERATE: '/admin-web/endpoint/v3/endpoint-installation-key/generate',
  ENDPOINT_SETTINGS_CONFIG_GET: '/admin-web/settings/v1/config/get',
  ENDPOINT_SETTINGS_CUSTOM_CHANGE: '/admin-web/settings/v1/custom-settings/change',
  PORTAL_DOMAINS_VERIFY: '/am-portal-svc/tenant-service/v2/domains/verify',
  PORTAL_DOMAINS_REGISTER: '/am-portal-svc/tenant-service/v2/domains/register',
  ENDPOINT_GROUPS_FIND: '/admin-web/endpoint-group/v2/endpoint-groups/find',
  ENDPOINT_GROUP_CREATE: '/admin-web/endpoint-group/v2/endpoint-group/create',
  ENDPOINT_GROUP_DELETE: '/admin-web/endpoint-group/v2/endpoint-group/delete',
  ENDPOINT_GROUP_ASSIGN: '/admin-web/endpoint-group/v2/endpoint-group/assign-endpoints',
  // Workstation settings and group overrides (admin-web workstation-settings v1)
  WORKSTATION_SETTINGS_VIEW_GET: '/admin-web/workstation-settings/v1/workstation-settings/view/get',
  WORKSTATION_SETTING_UPDATE: '/admin-web/workstation-settings/v1/workstation-settings/update',
  WORKSTATION_SETTING_RESET: '/admin-web/workstation-settings/v1/workstation-settings/reset',
  // Feature flags (feature-control v1)
  FEATURE_FLAGS_FIND: '/am-portal-svc/feature-control/v1/feature-flags/find',
  // Application Profiles (admin-web-app-profiles v1)
  APP_PROFILES_GET: '/admin-web/app-profiles/v1/app-profiles/get',
  APP_PROFILES_IMPORT: '/admin-web/app-profiles/v1/app-profiles/import',
  APP_PROFILES_DELETE: '/admin-web/app-profiles/v1/app-profiles/delete',
  // Import file-upload path for app profiles (admin-web-file-access v2).
  APP_PROFILE_PREPARE_UPLOAD: '/admin-web/file-access/v2/prepare-file-upload',
  // OIDC app integrations admin (oidc-applications-admin v1, EAMC-3327)
  OIDC_APP_ADMIN_CREATE: '/am-portal-svc/oidc-applications-admin/v1/create',
  OIDC_APP_ADMIN_FIND: '/am-portal-svc/oidc-applications-admin/v1/find',
  OIDC_APP_ADMIN_UPDATE: '/am-portal-svc/oidc-applications-admin/v1/update',
  OIDC_APP_ADMIN_DELETE: '/am-portal-svc/oidc-applications-admin/v1/delete',
} as const;

export enum ClientHeader {
  SETUP = 'am-portal-tenant-setup-web',
  IDP_WEB = 'idp-web',
}

export enum AMPortalService {
  AM_PORTAL_SETUP = '/am-portal-setup-svc',
  AM_PORTAL = '/am-portal-svc',
}

export enum SystemType {
  SETUP = 'SETUP',
  PORTAL = 'PORTAL',
}

export const CommonHeadersJson = { Accept: 'application/json', 'Content-Type': 'application/json' };

export const IdpChoices = {
  ENTRA_ID_VALUE: 'entraId',
  EXTERNAL_VALUE: 'external',
  NONE_VALUE: 'none',
} as const;

export const StorageKeys = {
  WORKFLOW_ID: 'ImprWorkflowId',
  TENANT_SETUP_STATE: 'tenantSetupState', // type SetupState
  DPA_STATUS: 'DPA_STATUS', // type DpaStatus
  DPA_DOCUMENT_NAME: 'DPA_DOCUMENT_NAME',
  DPA_DOCUMENT_URL: 'DPA_DOCUMENT_URL',
  ORG_EMAIL: 'orgEmail',
  IMPR_IDP_USED: 'IMPR_IDP_USED', // type boolean
  IMPR_IDP_USERNAME: 'IMPR_IDP_USERNAME',
  IMPR_IDP_DOMAIN: 'IMPR_IDP_DOMAIN',
  SAML_IDP_DOMAIN: 'SAML_IDP_DOMAIN',
};

export const RegexPatterns = {
  STRING_START: '^',
  REQUIRE_ALPHABETIC: '(?=.*[A-Za-z])',
  REQUIRE_NUMERIC: '(?=.*\\d)',
  REQUIRE_SPECIAL: '(?=.*[^A-Za-z\\d])',
  REQUIRE_LOWERCASE: '(?=.*[a-z])',
  REQUIRE_UPPERCASE: '(?=.*[A-Z])',
  STRING_END: '$',
};

export enum SetupState {
  STARTED = 'started',
  COMPLETED = 'completed',
}

export enum DpaStatus {
  GRANTED = 'GRANTED',
}

export enum ConsentGrantType {
  GRANTED = 'granted',
  NOT_GRANTED = 'not-granted',
  EMPTY = '',
}

export enum ConsentStatusType {
  UNKNOWN = 'unknown',
  VALID = 'valid',
  EXPIRED = 'expired',
  DECLINED = 'declined',
  NOT_REQUIRED = 'not-required',
}

export enum ConsentType {
  BIOMETRICS = 'impr.biometrics',
}

export enum SearchParams {
  BEARER_TOKEN = 'bt',
  TENANT_ID = 'tenantId',
  STATE = 'state',
  WINDOW_CLOSE_SEC = 'windowCloseSec',
  DISABLE_AUTO_COMPLETE = 'disableAutoComplete',
  REPORT = 'report',
  DISABLE_EPCS = 'disableEpcs',
  // An application whose edit modal opens on arrival, for example `edit=epic-hyperdrive`.
  EDIT_APP = 'edit',
}

export const defaultSystemData = { version: '1.0', osName: '', osVersion: '', computerName: '' };

// please add values as you need them
export enum Entitlement {
  EPCS = 'epcs',
  FACE_RECOGNITION = 'face-recognition',
  SSO = 'sso',
  RISK_BASED_ACCESS = 'risk-based-access',
}
